import React, { useEffect, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FILTER } from "../../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../../utils/date";
import {
  fetchVehicleTrim,
  initializeVehicleTrimScreen,
  setDeleteConfirmationPopupVisibility,
  exportVehicleTrim,
  saveVehicleTrimTableState
} from "../../../redux/actions/vehicles/vehicleTrim";
import VehicleTrim from '../../../component/Vehicles/VehicleTrim';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
function VehicleTrimScreen(props) {
  const {
    fetchVehicleTrim,
    initVehicleTrimScreen,
    showPageLevelLoader,
    vehicleTrimListview,
    paginationInfo,
    screenPermissions,
    exportVehicleTrim,
    isVehicleTrimExportError,
    isVehicleTrimExportSuccess,
    isLoading,
    savedTableState,
    saveVehicleTrimTableState,
  } = props;
  const navigate = useNavigate();

  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined
    };
  };

  useEffect(() => {
    initVehicleTrimScreen();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchVehicleTrim(savedParams);
    } else {
      fetchVehicleTrim({ sortField: 'id' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    fetchVehicleTrim(props);
  };

  const handleTableStateChange = (tableState) => {
    saveVehicleTrimTableState(tableState);
  };
  const handleCreateVehicleTrim = () => {
    navigate(APP_URLS.VEHICLE_TRIM.CREATE);
  }
  const editVehicleTrimRoute = (id) => {
    const path = generatePath(APP_URLS.VEHICLE_TRIM.EDIT, {
      id,
    });
    navigate(path);
  };
  const vehicleTrim = {
    handleCreateVehicleTrim,
    exportVehicleTrim,
    isVehicleTrimExportError,
    isVehicleTrimExportSuccess,
    editVehicleTrimRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    fetchVehicleTrims: loadLazyData,
    tableData: {
      columns: vehicleTrimListview?.columns,
      rows: vehicleTrimListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    savedTableState,
    onTableStateChange: handleTableStateChange,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <VehicleTrim
        {...vehicleTrim}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initVehicleTrimScreen: () => dispatch(initializeVehicleTrimScreen()),
    fetchVehicleTrim: (payload) => dispatch(fetchVehicleTrim(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportVehicleTrim: (payload) => dispatch(exportVehicleTrim(payload)),
    saveVehicleTrimTableState: (payload) => dispatch(saveVehicleTrimTableState(payload)),
  };
};


//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {

    isVehicleTrimCreateSuccess: selectFromVehicleTrimReducer(
      state,
      "isVehicleTrimCreateSuccess"
    ),
    vehicleTrimListview: selectFromVehicleTrimReducer(
      state,
      "vehicleTrimListview"
    ),
    showPageLevelLoader: selectFromVehicleTrimReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromVehicleTrimReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromVehicleTrimReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromVehicleTrimReducer(
      state,
      "isFetchingGridData"
    ),
    isVehicleTrimExportError: selectFromVehicleTrimReducer(
      state,
      "isVehicleTrimExportError"
    ),
    isVehicleTrimExportSuccess: selectFromVehicleTrimReducer(
      state,
      "isVehicleTrimExportSuccess"
    ),
    savedTableState: selectFromVehicleTrimReducer(
      state,
      "savedTableState"
    ),
    ...ownProps,
  };
};

const selectFromVehicleTrimReducer = (state, path) => {
  return selectVehicleTrimReducer(state)[path];
};

const selectVehicleTrimReducer = ({ vehicleTrimReducer }) => {
  return vehicleTrimReducer;
};


export default connect(mapStateToProps, mapDispatchToProps)(VehicleTrimScreen);
